import Vue from "vue";

export function getSeasonalLogos() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  let suffix = "";
  if (month === 12 && day >= 4) suffix = "-xmas";
  // else if (month === 10 && day >= 25) suffix = "-halloween";
  // else if (month === 4 && day >= 10 && day <= 20) suffix = "-easter";

  return {
    page: require(`@/assets/images/layout/logo-page${suffix}.svg`),
    dialog: require(`@/assets/images/layout/logo-dialog${suffix}.svg`),
    bigger: require(`@/assets/images/layout/logo-bigger${suffix}.svg`),
  } as const;
}

export const logos = getSeasonalLogos();
export type Logos = typeof logos;

Vue.prototype.$logos = logos;
